import { TBasicState } from './basicStateModel';

export const basicInitialState: TBasicState = {
  error: null,
  isPending: false
};
